import React from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/components/inputtext/InputText';
import { Tree } from 'primereact/tree';
import { TreeTable } from 'primereact/treetable';
import { Column } from 'primereact/column';
import {RadioButton} from 'primereact/radiobutton';
import MessageService from '../../service/MessageService';

export const FolderDialogTypes = Object.freeze({
    newFolder: 0,
    deleteFolder: 1,
    renameFolder: 2,
    copyFolder: 3,
    newSubFolder: 4,
    moveTableToFolder: 5,
    copyTable: 6,
    confirmDelete: 7
})

export default function FolderDialog(props) {
    const [folders, setFolders] = React.useState([]);
    const [newFolderName, setNewFolderName] = React.useState('');
    const [selectedFolder, setSelectedFolder] = React.useState(null);
    const messageService = new MessageService()
    const [isFolderSelected, setIsFolderSelected] = React.useState(false);


    const loadFolders = async (links) => {
        const tmpFolders = []
        if(props.type === FolderDialogTypes.moveTableToFolder) {
            const elementsData1 = await messageService.postVariableDirectory('directory', 'folder', props.right, 190, "FOLDER", '', false, links, null, '');
            const entries = elementsData1.data.contents['genesis.container.content.GenesisTMContent'].transfermodel.entrys;

            for (let ii = 0; ii < entries.length; ii += 1) {
                const c = {};
  
                c.key = ii;
                c.type = 'folder';
                c.objectNumber = 190;
                c.subtype = entries[ii].type;
                c.data = {};
                c.data.name = entries[ii].name;
                c.data.typ = entries[ii].typ;
                c.data.date = entries[ii].modifiedDatabaseTime;
                c.data.owner = entries[ii]?.ownerInfo?.user;
                c.data.id = entries[ii].id;
                c.data.protection = entries[ii].protection;
                c.data.folderCount = entries[ii].folderCount;
                c.data.structureCount = entries[ii].structureCount;
                c.data.typ = 'folder';
                c.selectable = c.data.id !== props.selectedFolder?.parentId
                c.leaf =true
                tmpFolders.push(c);
            }


            tmpFolders.forEach(folder => {
                if(folder.data.folderCount > 0)
                    folder.leaf = false
            })

            return tmpFolders
        }
    }

    React.useEffect( () => {
        setIsFolderSelected(!props.selectedFolder?.parentId)
        setSelectedFolder(null)
        
        if(props.type === FolderDialogTypes.renameFolder)
            setNewFolderName(props.selectedFolder.data.name)
        else
            setNewFolderName('')

        if(props.visible && props.type === FolderDialogTypes.moveTableToFolder)
            loadFolders([
                {
                    '@class': 'genesis.transfer.model.dto.directory.view.SimpleDirectoryLinkInfo',
                    type: 'FOLDER',
                    name: null,
                    reference: null,
                    id: -1,
                    shortDescription: '',
                    idList: [],
                }
            ]).then((result) => {
                setFolders(result)
            })
    },[props.visible, props.type, props.selectedFolder])

    const dialogTexts = React.useMemo(() => {
        const texts = {
            title: '',
            content: ''
        }

        switch(props.type) {
            case FolderDialogTypes.newFolder:
            case FolderDialogTypes.newSubFolder:
                texts.title = 'Neuen Ordner erstellen'
                texts.content = 'Bitte geben Sie einen Namen für den zu erstellenden Ordner ein.'
                break;
            case FolderDialogTypes.deleteFolder:
                texts.title = 'Ordner löschen'
                texts.content = 'Sind Sie sicher, dass Sie den Ordner "' + props.selectedFolder.data.name + '" unwiderruflich löschen möchten?'
                break;
            case FolderDialogTypes.renameFolder:
                texts.title = 'Ordner umbenennen'
                texts.content = 'Bitte geben Sie einen neuen Namen für den Ordner "' + props.selectedFolder.data.name + '" ein.'
                break;
            case FolderDialogTypes.copyFolder:
                texts.title = 'Ordner kopieren'
                texts.content = 'Bitte geben Sie einen neuen Namen für die Kopie des Ordners "' + props.selectedFolder.data.name + '" ein.'
                break;
            case FolderDialogTypes.moveTableToFolder:
                texts.title = 'Tabelle in Ordner verschieben'
                texts.content = 'Bitte wählen Sie den Zielordner für die Tabelle aus.'
                break;
            case FolderDialogTypes.confirmDelete:
                texts.title = 'Ordner löschen'
                texts.content = props.message
                break;
        }

        return texts
    },[props.type, props.message, props.selectedFolder])

    const onConfirm = React.useCallback(() => {
        try {
            if(isFolderSelected)
                props.onConfirm(newFolderName, selectedFolder)
            else
                props.onConfirm(newFolderName)
            
        }
        catch(e) {
            console.log(e)
        }
        finally {
            props.onHide()
        }
        
    },[newFolderName, selectedFolder, isFolderSelected])

    const correctFolderKeys = (nodes, parent = '') => {
        for(let i = 0; i < nodes.length; i++) {
            let key = i + 1;
            if(parent) key = `${parent}`.concat(`-${i}`)
            nodes[i].key = key;
            if(nodes[i].children) correctFolderKeys(nodes[i].children, key)
        }
    }

    const renderFooter = React.useMemo(() => {
        const buttons = [];

        if(props.type === FolderDialogTypes.newFolder || props.type === FolderDialogTypes.newSubFolder) {
            buttons.push(
                <Button
                    id="insert"
                    label="Erstellen"
                    icon="pi pi-check"
                    onClick={onConfirm}
                />
            )
        }
        
        if(props.type === FolderDialogTypes.deleteFolder || props.type === FolderDialogTypes.confirmDelete) {
            buttons.push(
                <Button
                    id="delete"
                    label="Löschen"
                    icon="pi pi-check"
                    onClick={onConfirm}
                />
            )
        }

        if(props.type === FolderDialogTypes.renameFolder) {
            buttons.push(
                <Button
                    id="delete"
                    label="Anwenden"
                    icon="pi pi-check"
                    onClick={onConfirm}
                />
            )
        }

        if(props.type === FolderDialogTypes.copyFolder || props.type === FolderDialogTypes.copyTable) {
            buttons.push(
                <Button
                    id="copy"
                    label="Kopieren"
                    icon="pi pi-check"
                    onClick={onConfirm}
                />
            )
        }

        if(props.type === FolderDialogTypes.moveTableToFolder) {
            buttons.push(
                <Button
                    disabled={!selectedFolder && isFolderSelected}
                    id="move"
                    label="Verschieben"
                    icon="pi pi-check"
                    onClick={onConfirm}
                />
            )
        }

        buttons.push(
            <Button
                id="cancel"
                label="Abbrechen"
                className="p-button-danger"
                icon="pi pi-times"
                onClick={() => props.onHide()}
            />
        );

        return (
            <div>
                {buttons}
            </div>
        )
    },[props.type, onConfirm, selectedFolder, isFolderSelected]);

    const onFolderTreeExpand = React.useCallback(async (e) => {
        if(!e.node.children) {
            const subFolders = await loadFolders([
                {
                    '@class': 'genesis.transfer.model.dto.directory.view.SimpleDirectoryLinkInfo',
                    type: 'FOLDER',
                    name: null,
                    reference: null,
                    id: e.node.data.id,
                    shortDescription: '',
                    idList: [],
                }
            ])
            console.log("onFolderExpand", folders)
            e.node.children = subFolders || []
            correctFolderKeys(folders)
            folders.forEach((folder) => {
                folder.parentId = e.node.data.id
            })
            setFolders([...folders])
        }
      }, [folders])

    const dialogContent = React.useMemo(() => {
        const elements = [];
        console.log("dialogContent", folders)
        if(props.type === FolderDialogTypes.newFolder 
            || props.type === FolderDialogTypes.newSubFolder
            || props.type === FolderDialogTypes.renameFolder
            || props.type === FolderDialogTypes.copyFolder)
        elements.push(
            <span className="p-float-label" style={{ marginTop: '2rem', marginBottom: '2rem' }}>
                <InputText
                autoFocus
                style={{ width: '20rem' }}
                id="dialogInpText"
                value={newFolderName}
                onChange={(e) => setNewFolderName( e.target.value )
                }
                />
                <label htmlFor="dialogInpText">Ordnername</label>
            </span>
        )

        if(props.type === FolderDialogTypes.moveTableToFolder || props.type === FolderDialogTypes.copyTable) {
            correctFolderKeys(folders || [])
            elements.push(
            <div className="p-grid">
                <div className="p-col-12">
                    <RadioButton disabled={!props.selectedFolder?.parentId} inputId="rb1" name="isFolderSelected" value={false} onChange={(e) => setIsFolderSelected(e.value)} checked={!isFolderSelected} />
                    <label htmlFor="rb1" className="p-radiobutton-label">Keinen Ordner (oberste Ebene)</label>
                </div>
                <div className="p-col-12">
                    oder
                </div>
                <div className="p-col-12">
                    <RadioButton inputId="rb2" name="isFolderSelected" value={true} onChange={(e) => setIsFolderSelected(e.value)} checked={isFolderSelected} />
                    <label htmlFor="rb2" className="p-radiobutton-label">Zielordner auswählen</label>
                    {
                        isFolderSelected &&
                        <TreeTable

                            onExpand={onFolderTreeExpand}
                            value={folders}
                            selectionMode="single"
                            onSelect={(e) => setSelectedFolder(e.node)}
                            selectionKeys={selectedFolder?.key}
                        >
                            <Column
                                body={(node) => 
                                    <span>
                                        <i title="Ordner" className="pi pi-md-folder" style={{
                                            "verticalAlign": "text-bottom"
                                        }}/>
                                        {node.data.name}
                                    </span>
                                }
                                header="Ordner-/Objektname"
                                expander
                            />
                        </TreeTable>
                    }
                </div>
            </div>
            )
    }

        return (
            <>
                {elements}
            </>
        )
    }, [props.type, newFolderName, selectedFolder, folders, isFolderSelected])

    return (
        <Dialog
            header={dialogTexts.title}
            visible={props.visible}
            style={{ width: '30vw' }}
            footer={renderFooter}
            onHide={props.onHide}
            modal
        >
            <h3>{dialogTexts.content}</h3>
            {dialogContent}
        </Dialog>
    );
}